import WidgetNivoLine from "./Widget.nivo.line";
import WidgetNivoBar from "./Widget.nivo.bar";
import WidgetPie from "./Widget.nivo.pie";
import WidgetSunburst from "./Widget.nivo.sunburst";

const NivoWidgets = {
  Line: WidgetNivoLine,
  Bar: WidgetNivoBar,
  Pie: WidgetPie,
  Sunburst: WidgetSunburst
}

export default NivoWidgets;
